/**
 * @generated SignedSource<<415a9a89a0e7230ccb300cf7d58aeb27>>
 * @relayHash 3610180b2619c3becd2c82f45e0934c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f5df264b8cdfc037a09cc9a3d9abd1ff2e9980516b81c65b8632f61ce9af9f56

import type { ConcreteRequest, Query } from 'relay-runtime';
export type EditorRevertDialogContentQuery$variables = {
  contentId?: string | null | undefined;
  status?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type EditorRevertDialogContentQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly links: {
        readonly context: string | null | undefined;
        readonly webui: string | null | undefined;
      } | null | undefined;
      readonly metadata: {
        readonly labels: ReadonlyArray<{
          readonly id: string | null | undefined;
          readonly name: string | null | undefined;
        } | null | undefined> | null | undefined;
      };
      readonly type: string | null | undefined;
      readonly version: {
        readonly number: number | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type EditorRevertDialogContentQuery = {
  response: EditorRevertDialogContentQuery$data;
  variables: EditorRevertDialogContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "type"
          },
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "number"
              }
            ]
          },
          {
            "concreteType": "ContentMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "concreteType": "Label",
                "kind": "LinkedField",
                "name": "labels",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "webui"
              },
              {
                "kind": "ScalarField",
                "name": "context"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "EditorRevertDialogContentQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditorRevertDialogContentQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "3610180b2619c3becd2c82f45e0934c3",
    "id": "f5df264b8cdfc037a09cc9a3d9abd1ff2e9980516b81c65b8632f61ce9af9f56",
    "metadata": {},
    "name": "EditorRevertDialogContentQuery",
    "operationKind": "query",
    "text": "query EditorRevertDialogContentQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,version{number},metadata{labels{id,name}},links{webui,context}}}}"
  }
};
})();

(node as any).hash = "db72d9646e7ccd29c2e4d2affd2a90ce";

export default node;
